<app-dialog-banner text="Escalation &amp; Approval" i18n-text [dialogRef]="dialogRef"></app-dialog-banner>

<div class="agenda-dialog" [attr.data-form-ready]="ready ? 'true' : null">
    <h3 class="question" i18n>How should this request be escalated?</h3>

    <h4 class="option-heading" i18n>Include on the agenda of a channel's meetings, as they are scheduled?</h4>
    <div class="option-body">
        <p class="muted explanation" i18n>
            No meeting needs to be scheduled yet. Pick a channel and this request is
            by default added to the agenda of future meetings until the request is accepted as complete</p>
        <mat-form-field class="channel-picker" subscriptSizing="dynamic">
            <mat-label i18n>Channel</mat-label>
            <mat-select [(ngModel)]="selectedForumId" data-field="forumId">
                @for (channel of channels; track channel.id) {
                    <mat-option [value]="channel.id">{{ channel.name }}</mat-option>
                }
            </mat-select>
        </mat-form-field>
    </div>

    <h4 class="option-heading" i18n>Add to meetings already scheduled?</h4>
    <div class="option-body">
        @for (ballot of openBallots; track ballot.id) {
            <div class="agenda-row ballot">
                <mat-checkbox [checked]="isTicked(ballot)" [disabled]="isOnAgenda(ballot)"
                              [matTooltip]="addToAgendaHint(ballot)" [attr.data-add-to-agenda]="ballot.id"
                              (change)="setTicked(ballot, $event.checked)"></mat-checkbox>
                <span class="ballot-date">
                    @if (ballot.opensAt) {
                        {{ ballot.opensAt * 1000 | date:'d MMM y' }}
                    } @else {
                        <ng-container i18n>Unscheduled</ng-container>
                    }
                </span>
                <span class="ballot-title"><a [routerLink]="ballotLink(ballot)" [attr.data-ballot-link]="ballot.id"
                                             i18n-matTooltip matTooltip="Open the meeting details"
                                             (click)="dialogRef.close()">{{ ballot.title }}</a><span class="muted channel-name">({{ ballot.forum?.name }})</span></span>
                @if (isOnAgenda(ballot)) {
                    <span class="on-agenda" [attr.data-on-agenda]="ballot.id" i18n>(On Agenda)</span>
                }
            </div>
        } @empty {
            <p class="muted explanation" i18n>No meetings are scheduled yet. Pick a channel above and this request
                will be on the agenda of its next meeting.</p>
        }
    </div>

    <h4 class="option-heading schedule-new">
        <span i18n>Schedule a new meeting just for this request?</span>
        <mat-checkbox [(ngModel)]="scheduleNewMeeting" data-schedule-now
                      i18n-matTooltip matTooltip="On Finish, schedule a special purpose meeting to discuss and / or approve this request"></mat-checkbox>
    </h4>

    <div class="agenda-nav">
        <button mat-button (click)="dialogRef.close()" i18n>Cancel</button>
        <button mat-raised-button color="primary" data-save-button [disabled]="!hasChanges"
                (click)="finish()" i18n>Finish</button>
    </div>
</div>
